import React, { useState } from 'react';
import { Select, Input, Radio } from 'antd';
import Currency from '$app/components/vendor/Currency';
import config from '$config';
import { BOOKING_STATUS } from '../../../../constants';
import './styles.scss';

const { Option } = Select;
const { TextArea } = Input;

const cancelReasons = {
  'C&D-related': [
    'Car breakdown (unusable) - Customer',
    'Customer Parking Issue - Garages',
    'Failed collection - Driver Late or Unavailable - Drivers',
    "Garage can't offer collection and delivery - Garages",
    'Garage late/failed to collect - Garages',
    'Car dangerous to be driven - Customer',
    'Car needs recovery, customer denied - Customer',
  ],
  'Changes in customer circumstances': [
    'Job no longer required, car fixed - Customer',
    'Customer decided to sell car before job - Customer',
    'Customer no show - Customer',
    'Customer car stolen - Customer',
    'Customer unresponsive - Customer',
    'MOT done already - Customer',
  ],
  'Concerns/complaints': [
    'Customer concerned about bad reviews - Customer',
    'Customer concerned about booking not happening - Customer',
    'Customer not happy with the reviews of the garage - Garages',
  ],
  Customer: [
    'Locking Wheel Nut unavailable - Customer',
    'Duplicate Booking - Customer',
    'RTW - CS',
    'Wants to DIY the job - Customer',
    'Booking made by accident - Customer',
  ],
  Fraud: ['Fraud Booking - Fixter'],
  'Garage Related': [
    'Booked directly with garage - Garages',
    'Garage wants to do diagnosis first, customer not happy - Garages',
  ],
  'Location-related': ['Customer found closer garage - Garages'],
  'New Booking Needed': [
    'Discount did not apply/Wrong Coupon Applied - Product',
    'Customer C&D changed to Garage C&D - Product',
    'Incorrect details provided - Customer',
  ],
  'Non-availability': [
    'Garage not adhering to the opening & closing time - Garages',
    'No Garage Available - Garages',
    'No Driver Available - Drivers',
    'Original garage changed (Customer C&D) - Garages',
    'Garage unable to perform work - Garages',
    "Garage doesn't have correct tool - Garages",
    "Garage doesn't have skilled technician - Garages",
    "Garage doesn't do big jobs - Garages",
    'Cannot offer just labour/Customer sourcing the parts - Fixter',
    'Class VII vehicle - Garages',
    'Customer booked free check - Product',
  ],
  'Parts Related': [
    'Parts not delivered - Garages',
    'Wrong parts delivered - Garages',
    'Parts on backorder - Garages',
    'Main dealer parts only - Garages',
  ],
  'Price-related': [
    'Customer found cheaper garage - Customer',
    'Price increased, customer not willing to pay - Fixter',
    'Unable to afford the work - Customer',
  ],
  'Saturday Booking': ["Customer can't do weekday - Product"],
  'Time-related': [
    'Customer found earlier booking - Garages',
    'Drivers changed collection date/time, not suitable - Drivers',
    'Customer no longer available on the booking date - Customer',
    'Garage changed booking date/time, not suitable - Garages',
    'Garage changed booking date/time, customer unresponsive - Garage',
  ],
  Other: ['Other - Other'],
};

const cancelReasonCategories = Object.keys(cancelReasons);

export default (props) => {
  const { booking, actionStore } = props;
  const [valueTextArea, setValueTextArea] = useState(null);
  const [displayTextField, setDisplayTextField] = useState(false);
  const [freeCancellation, setFreeCancellationFee] = useState('yes');
  const [payGarageCD, setPayGarageCD] = useState(true);

  const [selectedCancellationCategory, setSelectedCancellationCategory] = useState(undefined);

  const [selectedReasonForCancellation, setReasonForCancellation] = useState(undefined);
  const [cancellationReasonsDisabled, setCancellationReasonsDisabled] = useState(true);
  const [displayCancellationReasons, setDisplayCancellationReasons] = useState(true);

  const setCancellationReason = (reason) => {
    setReasonForCancellation(reason);
    return (actionStore['cancel.booking.reason'] = reason);
  };

  const decideDisplayTextField = (reason) => {
    if (reason === 'Other') {
      setDisplayCancellationReasons(false);
      setDisplayTextField(true);
    } else {
      setDisplayTextField(false);
      setValueTextArea(null);
    }
  };

  const handleCancellationCategoryChange = (category) => {
    setSelectedCancellationCategory(category);
    setDisplayCancellationReasons(true);
    setCancellationReasonsDisabled(false);
    setCancellationReason(undefined);
    decideDisplayTextField(category);
  };

  const onChangeTextArea = ({ target: { value } }) => {
    setValueTextArea(value);
    return (actionStore['cancel.booking.reason'] = `Other - ${value}`);
  };

  return (
    <div className="cancellation-modal-contents">
      <p>
        Cancellation reason <span className="asterisk">*</span>
      </p>
      <Select
        style={{ width: 470 }}
        value={selectedCancellationCategory}
        onChange={handleCancellationCategoryChange}
        placeholder="Select cancellation category"
      >
        {cancelReasonCategories.map((category) => (
          <Option key={category} value={category}>
            {category}
          </Option>
        ))}
      </Select>

      {displayCancellationReasons && (
        <Select
          onChange={(reason) => {
            setCancellationReason(reason);
          }}
          style={{ width: 470 }}
          placeholder="Select cancellation reason"
          disabled={cancellationReasonsDisabled}
          value={selectedReasonForCancellation}
        >
          {selectedCancellationCategory &&
            cancelReasons[selectedCancellationCategory].map((reason) => (
              <Option key={reason} value={reason}>
                {reason}
              </Option>
            ))}
        </Select>
      )}

      {displayTextField && (
        <div>
          <br />
          <b>
            Please specify the reason below<span style={{ color: 'red' }}>&#42;</span>
          </b>
          <TextArea
            value={valueTextArea}
            onChange={onChangeTextArea}
            autosize={{ minRows: 2, maxRows: 4 }}
            style={{ width: 470 }}
          />
        </div>
      )}

      <p className="note">All repairs/services will be removed.</p>

      <p className="charge-customer">
        Customer charge <span className="asterisk">*</span>
      </p>

      <Radio.Group
        value={freeCancellation}
        defaultValue="yes"
        onChange={(free) => {
          const noCancellationFee = free.target.value;
          setFreeCancellationFee(noCancellationFee);
          return (actionStore['cancel.booking.free'] = noCancellationFee);
        }}
      >
        <Radio value="no">
          Charge <Currency>{config.defaultCancellationFee || 2000}</Currency> cancellation fee
        </Radio>
        <Radio value="yes">No Fee</Radio>
      </Radio.Group>
      <br />
      <br />

      {((booking.collectionDeliveryOption === 'GarageC&D' &&
        (booking.masterStatusId < BOOKING_STATUS.WORK_COMPLETE ||
          booking.masterStatusId === BOOKING_STATUS.GARAGE_DECLINED)) ||
        booking.masterStatusId === BOOKING_STATUS.DISPUTE) && (
        <div>
          <p>
            Garage payment <span className="asterisk">*</span>
          </p>

          <Radio.Group
            value={payGarageCD}
            defaultValue
            onChange={(option) => {
              const payGarageCDBool = option.target.value;
              setPayGarageCD(payGarageCDBool);
              return (actionStore['cancel.booking.payGarageCD'] = payGarageCDBool);
            }}
          >
            <Radio value>Pay £12 to Garage</Radio>
            <Radio value={false}>No Payment</Radio>
          </Radio.Group>
          <br />
          <br />
        </div>
      )}
    </div>
  );
};
